<template>
  <div class="design-tab">
    <div class="row">
      <div class="col-md-6 mb-3">
        <label class="form-label">Background Color</label>
        <input
          type="color"
          class="form-control form-control-color"
          :value="component.design.backgroundColor || '#ffffff'"
          @input="updateDesign('backgroundColor', ($event.target as HTMLInputElement).value)"
        />
      </div>

      <div class="col-md-6 mb-3">
        <label class="form-label">Text Color</label>
        <input
          type="color"
          class="form-control form-control-color"
          :value="component.design.textColor || '#000000'"
          @input="updateDesign('textColor', ($event.target as HTMLInputElement).value)"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 mb-3">
        <label class="form-label">Font Size</label>
        <input
          type="text"
          class="form-control"
          placeholder="e.g., 16px, 1rem"
          :value="component.design.fontSize"
          @input="updateDesign('fontSize', ($event.target as HTMLInputElement).value)"
        />
      </div>

      <div class="col-md-6 mb-3">
        <label class="form-label">Font Weight</label>
        <select
          class="form-select"
          :value="component.design.fontWeight"
          @change="updateDesign('fontWeight', ($event.target as HTMLSelectElement).value)"
        >
          <option value="">Default</option>
          <option value="300">Light (300)</option>
          <option value="400">Normal (400)</option>
          <option value="500">Medium (500)</option>
          <option value="600">Semi-Bold (600)</option>
          <option value="700">Bold (700)</option>
        </select>
      </div>
    </div>

    <div class="mb-3">
      <label class="form-label">Padding</label>
      <input
        type="text"
        class="form-control"
        placeholder="e.g., 10px, 1rem 2rem"
        :value="component.design.padding"
        @input="updateDesign('padding', ($event.target as HTMLInputElement).value)"
      />
    </div>

    <div class="mb-3">
      <label class="form-label">Margin</label>
      <input
        type="text"
        class="form-control"
        placeholder="e.g., 10px 0, 1rem"
        :value="component.design.margin"
        @input="updateDesign('margin', ($event.target as HTMLInputElement).value)"
      />
    </div>

    <div class="row">
      <div class="col-md-6 mb-3">
        <label class="form-label">Width</label>
        <input
          type="text"
          class="form-control"
          placeholder="e.g., 100%, 300px"
          :value="component.design.width"
          @input="updateDesign('width', ($event.target as HTMLInputElement).value)"
        />
      </div>

      <div class="col-md-6 mb-3">
        <label class="form-label">Height</label>
        <input
          type="text"
          class="form-control"
          placeholder="e.g., auto, 200px"
          :value="component.design.height"
          @input="updateDesign('height', ($event.target as HTMLInputElement).value)"
        />
      </div>
    </div>

    <h6 class="mb-3">Border</h6>
    <div class="row">
      <div class="col-md-4 mb-3">
        <label class="form-label">Width</label>
        <input
          type="text"
          class="form-control"
          placeholder="e.g., 1px"
          :value="component.design.borderWidth"
          @input="updateDesign('borderWidth', ($event.target as HTMLInputElement).value)"
        />
      </div>

      <div class="col-md-4 mb-3">
        <label class="form-label">Style</label>
        <select
          class="form-select"
          :value="component.design.borderStyle"
          @change="updateDesign('borderStyle', ($event.target as HTMLSelectElement).value)"
        >
          <option value="">None</option>
          <option value="solid">Solid</option>
          <option value="dashed">Dashed</option>
          <option value="dotted">Dotted</option>
          <option value="double">Double</option>
        </select>
      </div>

      <div class="col-md-4 mb-3">
        <label class="form-label">Color</label>
        <input
          type="color"
          class="form-control form-control-color"
          :value="component.design.borderColor || '#dee2e6'"
          @input="updateDesign('borderColor', ($event.target as HTMLInputElement).value)"
        />
      </div>
    </div>

    <div class="mb-3">
      <label class="form-label">Border Radius</label>
      <input
        type="text"
        class="form-control"
        placeholder="e.g., 4px, 0.5rem"
        :value="component.design.borderRadius"
        @input="updateDesign('borderRadius', ($event.target as HTMLInputElement).value)"
      />
    </div>

    <h6 class="mb-3">Flexbox (for containers/columns)</h6>
    <div class="row">
      <div class="col-md-6 mb-3">
        <label class="form-label">Display</label>
        <select
          class="form-select"
          :value="component.design.display"
          @change="updateDesign('display', ($event.target as HTMLSelectElement).value)"
        >
          <option value="">Default</option>
          <option value="flex">Flex</option>
          <option value="block">Block</option>
          <option value="inline-block">Inline Block</option>
        </select>
      </div>

      <div class="col-md-6 mb-3">
        <label class="form-label">Flex Direction</label>
        <select
          class="form-select"
          :value="component.design.flexDirection"
          @change="updateDesign('flexDirection', ($event.target as HTMLSelectElement).value)"
        >
          <option value="">Default</option>
          <option value="row">Row</option>
          <option value="column">Column</option>
        </select>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 mb-3">
        <label class="form-label">Justify Content</label>
        <select
          class="form-select"
          :value="component.design.justifyContent"
          @change="updateDesign('justifyContent', ($event.target as HTMLSelectElement).value)"
        >
          <option value="">Default</option>
          <option value="flex-start">Start</option>
          <option value="center">Center</option>
          <option value="flex-end">End</option>
          <option value="space-between">Space Between</option>
          <option value="space-around">Space Around</option>
        </select>
      </div>

      <div class="col-md-6 mb-3">
        <label class="form-label">Align Items</label>
        <select
          class="form-select"
          :value="component.design.alignItems"
          @change="updateDesign('alignItems', ($event.target as HTMLSelectElement).value)"
        >
          <option value="">Default</option>
          <option value="flex-start">Start</option>
          <option value="center">Center</option>
          <option value="flex-end">End</option>
          <option value="stretch">Stretch</option>
        </select>
      </div>
    </div>

    <div class="mb-3">
      <label class="form-label">Gap</label>
      <input
        type="text"
        class="form-control"
        placeholder="e.g., 10px, 1rem"
        :value="component.design.gap"
        @input="updateDesign('gap', ($event.target as HTMLInputElement).value)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { FormComponent, DesignStyles } from '../../types/form-builder';

interface Props {
  component: FormComponent;
}

interface Emits {
  (e: 'update', updates: Partial<FormComponent>): void;
}

const props = defineProps<Props>();
const emit = defineEmits<Emits>();

function updateDesign(field: keyof DesignStyles, value: string) {
  emit('update', {
    design: {
      ...props.component.design,
      [field]: value || undefined,
    },
  });
}
</script>
